export const API_ENDPOINT = {
    AUTH_USER: '/api/auth/user',
    AUTH_AUTHCODE: 'api/auth/checkcode',
    AUTH_FORGOT_PASSWORD: 'api/auth/forgot-password',
    AUTH_RESET_PASSWORD: 'api/auth/reset-password',
    USER_INVITE: '/api/user/invite',
    USER_REGISETER: '/api/auth/register',
    USER_LIST: '/api/user/list',
    USER_INFO: '/api/user/info',
    USER_EDIT_SAVE: '/api/user/settings/edit',
    USER_REMOVE: '/api/user/remove',
    USER_RESTORE: '/api/user/restore',
    SETTINGS_EDIT_SAVE: '/api/settings/edit',
    SETTINGS_PASSWORD_SAVE: '/api/settings/password',
}

/**
 * 占い計算 API（ne-api-server）のベース URL。
 * ローカルで ne-api-server を立てる場合は .env に MIX_NE_API_BASE_URL を設定する（例: http://127.0.0.1:3000）。
 */
const PROD_NE_API_BASE_URL =
    process.env.MIX_NE_API_PROD_BASE_URL ||
    'https://grdxf7f6l8.execute-api.ap-northeast-1.amazonaws.com/Prod'
const DEV_NE_API_BASE_URL =
    process.env.MIX_NE_API_BASE_URL ||
    'https://deaxdfud35.execute-api.ap-northeast-1.amazonaws.com/Prod'

const BASE_URL =
    process.env.NODE_ENV === 'production'
        ? PROD_NE_API_BASE_URL
        : DEV_NE_API_BASE_URL

export const NE_API_ENDPOINT = {
    LOCATION_COUNTRY_LIST: `${BASE_URL}/api/v1/loc/country/list`,
    LOCATION_CITY_LIST: `${BASE_URL}/api/v1/loc/city/list`,
    LOCATION_TIME_DIFF: `${BASE_URL}/api/v1/loc/time/diff`,
    LIGHT_COMPASS_CREATE: `${BASE_URL}/api/v1/lightcompass/create`,
    MASTER_CHART_CREATE: `${BASE_URL}/api/v1/masterchart/create`,
    PASSPORT_CREATE: `${BASE_URL}/api/v1/passport/create`,
    PUBLIC_PASSPORT_PDF_JOBS: `${BASE_URL}/api/v1/public/passport/pdf/jobs`,
    PUBLIC_PASSPORT_PDF_RENDER: `${BASE_URL}/api/v1/public/passport/pdf/render`,
    YEAR_FORTUNE_CREATE: `${BASE_URL}/api/v1/year-fortune/create`,
}
